(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["adeline-categories"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    const run = root => root.querySelectorAll('.adeline-cats').forEach(el => {
      if (el.dataset.motion) return;
      el.dataset.motion = '1';
      if (el.getBoundingClientRect().top < innerHeight * .9) return;
      el.classList.add('is-pending');
      const io = new IntersectionObserver(entries => entries.forEach(e => {
        if (!e.isIntersecting) return;
        el.classList.add('is-in'); el.classList.remove('is-pending'); io.disconnect();
      }), { threshold: .15 });
      io.observe(el);
    });
    run(document);
    document.addEventListener('shopify:section:load', e => run(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["adeline-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduce = matchMedia('(prefers-reduced-motion: reduce)');
    const init = root => root.querySelectorAll('[data-adeline-story]').forEach(el => {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      if (reduce.matches || !('IntersectionObserver' in window)) return;
      const img = el.querySelector('[data-parallax]');
      if (el.getBoundingClientRect().top > innerHeight * .85) {
        el.classList.add('is-pending');
      }
      let visible = false, ticking = false;
      const move = () => {
        ticking = false;
        if (!img || !visible) return;
        const r = el.getBoundingClientRect();
        const p = (r.top + r.height / 2 - innerHeight / 2) / (innerHeight / 2 + r.height / 2);
        img.style.transform = `translate3d(0, ${(p * -6).toFixed(2)}%, 0)`;
      };
      const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(move); } };
      new IntersectionObserver(entries => entries.forEach(e => {
        visible = e.isIntersecting;
        if (visible) {
          if (e.intersectionRatio > .2) { el.classList.add('is-in'); el.classList.remove('is-pending'); }
          addEventListener('scroll', onScroll, { passive: true }); move();
        } else {
          removeEventListener('scroll', onScroll);
        }
      }), { threshold: [0, .2, .5] }).observe(el);
    });
    init(document);
    document.addEventListener('shopify:section:load', e => init(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["adeline-testimonials"] && !Shopify.designMode) return;
  try {
    
  class AdelineCustomerVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video || this.dataset.autoplay !== 'true' || !('IntersectionObserver' in window)) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.connection = navigator.connection;
      this.visible = false;
      this.userPaused = false;
      this.autoPaused = true;
      this.video.muted = true;
      this.video.addEventListener('pause', () => {
        if (!this.autoPaused) this.userPaused = true;
      }, options);
      this.video.addEventListener('play', () => {
        this.autoPaused = false;
        this.userPaused = false;
        if (!this.visible || document.hidden) this.pauseAutomatically();
      }, options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.55;
        this.updatePlayback();
      }, { threshold: [0, 0.55] });
      this.observer.observe(this.video);
      document.addEventListener('visibilitychange', () => this.updatePlayback(), options);
      this.motion.addEventListener('change', () => this.updatePlayback(), options);
      this.connection?.addEventListener('change', () => this.updatePlayback(), options);
    }
    pauseAutomatically() {
      if (this.video && !this.video.paused) {
        this.autoPaused = true;
        this.video.pause();
      }
    }
    updatePlayback() {
      if (!this.visible || document.hidden || (!this.manualPlayback && (this.motion.matches || this.connection?.saveData))) {
        this.pauseAutomatically();
        return;
      }
      if (!this.userPaused && this.video.paused) this.video.play().catch(() => {});
    }
    setPlayback(playing) {
      this.userPaused = !playing;
      this.manualPlayback = playing;
      if (playing) this.updatePlayback();
      else this.pauseAutomatically();
    }
    disconnectedCallback() {
      this.pauseAutomatically();
      this.observer?.disconnect();
      this.controller?.abort();
    }
  }
  if (!customElements.get('adeline-customer-video')) customElements.define('adeline-customer-video', AdelineCustomerVideo);
  class AdelineVideoToggle extends HTMLElement {
    connectedCallback() {
      this.players = [...this.closest('.adeline-testimonials').querySelectorAll('adeline-customer-video')];
      if (!this.players.length || !('IntersectionObserver' in window)) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.button = this.querySelector('button');
      this.button.addEventListener('click', () => {
        const playing = this.players.some(player => !player.video.paused);
        this.players.forEach(player => player.setPlayback(!playing));
        this.updateLabel();
      }, options);
      this.players.forEach(player => {
        player.video.addEventListener('play', () => this.updateLabel(), options);
        player.video.addEventListener('pause', () => this.updateLabel(), options);
      });
      this.hidden = false;
      this.updateLabel();
    }
    updateLabel() {
      this.button.textContent = this.players.some(player => !player.video.paused) ? this.dataset.pause : this.dataset.play;
    }
    disconnectedCallback() { this.controller?.abort(); }
  }
  if (!customElements.get('adeline-video-toggle')) customElements.define('adeline-video-toggle', AdelineVideoToggle);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
